import * as Tabs from '@radix-ui/react-tabs';
import { useStore } from '@/state/store';

/** Persistent Simple / Advanced toggle in the header (§10.1). */
export function ComplexityToggle() {
  const mode = useStore((s) => s.ui.complexityMode);
  const setUi = useStore((s) => s.setUi);
  return (
    <Tabs.Root value={mode} onValueChange={(v) => void setUi({ complexityMode: v as 'simple' | 'advanced' })}>
      <Tabs.List
        aria-label="Complexity mode"
        className="inline-flex rounded-md border border-slate-300 p-0.5 text-sm dark:border-slate-600"
      >
        <Tabs.Trigger
          value="simple"
          className="rounded px-3 py-1 data-[state=active]:bg-sky-600 data-[state=active]:text-white"
        >
          Simple
        </Tabs.Trigger>
        <Tabs.Trigger
          value="advanced"
          className="rounded px-3 py-1 data-[state=active]:bg-sky-600 data-[state=active]:text-white"
        >
          Advanced
        </Tabs.Trigger>
      </Tabs.List>
    </Tabs.Root>
  );
}
